import React from "react";
import { Link } from "react-router-dom";
import brandFullTransparent from "../assets/brand-full-transparent.png";
import { useLanguage } from "../lib/language";

function TermsPage() {
  const { language, toggleLanguage } = useLanguage();
  const isArabic = language === "ar";

  const copy = isArabic
    ? {
        back: "العودة إلى التسجيل",
        eyebrow: "الشروط والأحكام",
        title: "شروط وأحكام وسياسة خصوصية Learnova",
        intro:
          "باستخدامك لمنصة Learnova فإنك توافق على الشروط التالية المتعلقة باستخدام النظام، وإدارة البيانات، وحماية حقوق شركة ليرنوفا والمستخدمين.",
        sections: [
          {
            title: "1. ملكية المنصة والمحتوى",
            points: [
              "منصة Learnova وجميع عناصرها البرمجية والتنظيمية وواجهاتها مملوكة لشركة ليرنوفا.",
              "لا يجوز نسخ المنصة أو إعادة بيعها أو استخدامها خارج الأغراض التعليمية أو التشغيلية المصرح بها دون موافقة كتابية من ليرنوفا.",
              "تحتفظ ليرنوفا بحق تطوير النظام وتعديل خصائصه وتحسينه بما يخدم جودة الخدمة."
            ]
          },
          {
            title: "2. استخدام الحساب",
            points: [
              "يلتزم المستخدم بتقديم بيانات صحيحة ودقيقة أثناء التسجيل.",
              "المستخدم مسؤول عن سرية بيانات الدخول الخاصة به وعدم مشاركتها مع الآخرين.",
              "يحق للمنصة تعليق أي حساب يثبت استخدامه بشكل مسيء أو مخالف أو يعرّض البيانات للخطر."
            ]
          },
          {
            title: "3. البيانات الشخصية",
            points: [
              "تقوم المنصة بجمع البيانات التي يدخلها المستخدم مثل الاسم والبريد الإلكتروني والعمر والمحافظة والمرحلة التعليمية والرقم القومي عند الحاجة التشغيلية.",
              "تُستخدم هذه البيانات لتحسين إدارة التقييمات، وإخراج التقارير، وتحليل المشاركة، ورفع جودة العملية التعليمية.",
              "يلتزم المستخدم بإدخال بياناته الحقيقية، ويجوز للمنصة رفض أو مراجعة أي بيانات غير واضحة أو متناقضة."
            ]
          },
          {
            title: "4. الخصوصية وحماية البيانات",
            points: [
              "تتعهد Learnova بعدم بيع البيانات الشخصية أو مشاركتها مع أطراف خارجية دون سبب مشروع أو متطلب قانوني.",
              "يمكن استخدام البيانات بصورة مجمعة أو إحصائية لتحليل الأداء والمشاركة دون الإضرار بحقوق المستخدمين.",
              "تتخذ المنصة إجراءات معقولة لحماية البيانات، لكن الاستخدام عبر الإنترنت يظل معرضًا لمخاطر تقنية معتادة."
            ]
          },
          {
            title: "5. التقييمات والنتائج",
            points: [
              "قد تعرض المنصة نتائج أو تقارير أو تحليلات أو توصيات تعتمد على البيانات المدخلة وإعدادات المدرب.",
              "تُستخدم تقارير الذكاء الاصطناعي كمساعدة تعليمية ولا يجب اعتبارها وحدها بديلاً عن الحكم البشري أو التقييم الأكاديمي النهائي.",
              "يخضع ظهور النتائج أو الإجابات أو التقرير الذكي لإعدادات الصلاحيات التي يحددها المدرب أو إدارة النظام."
            ]
          },
          {
            title: "6. الاستخدام المقبول",
            points: [
              "يمنع استخدام المنصة في إدخال بيانات مزيفة أو مسيئة أو منتهكة للقانون أو حقوق الغير.",
              "يمنع أي محاولة للوصول غير المصرح به إلى حسابات أو بيانات أو مسارات إدارية.",
              "يمنع استخدام المنصة بطريقة تؤثر سلبًا على استقرار الخدمة أو سلامة قاعدة البيانات."
            ]
          },
          {
            title: "7. حدود المسؤولية",
            points: [
              "تبذل Learnova جهدًا معقولًا للحفاظ على استمرارية الخدمة وصحة البيانات، لكنها لا تضمن خلو النظام من الانقطاعات أو الأخطاء بنسبة مطلقة.",
              "لا تتحمل ليرنوفا مسؤولية الأضرار الناتجة عن سوء استخدام الحساب أو إدخال بيانات غير صحيحة من المستخدم.",
              "يجب مراجعة أي تقارير أو قرارات تعليمية مهمة بواسطة المسؤول أو المدرب المختص."
            ]
          },
          {
            title: "8. التعديلات",
            points: [
              "يجوز لشركة ليرنوفا تعديل هذه الشروط عند الحاجة التنظيمية أو القانونية أو التشغيلية.",
              "استمرار استخدام المنصة بعد تحديث الشروط يُعد قبولًا ضمنيًا بها."
            ]
          }
        ]
      }
    : {
        back: "Back to Register",
        eyebrow: "Terms",
        title: "Learnova Terms, Conditions, and Privacy Notice",
        intro:
          "By using Learnova, you agree to the following terms governing platform usage, data handling, and the rights of Learnova and its users.",
        sections: [
          {
            title: "1. Platform Ownership",
            points: [
              "Learnova and its software, workflows, interface structure, and operational assets are owned by Learnova.",
              "The platform may not be copied, resold, or used outside approved educational or operational purposes without written permission.",
              "Learnova reserves the right to improve, extend, and modify the service when needed."
            ]
          },
          {
            title: "2. Account Usage",
            points: [
              "Users must provide accurate and truthful registration data.",
              "Each user is responsible for keeping their login credentials confidential.",
              "Accounts may be suspended if they are used in a harmful, abusive, or unauthorized way."
            ]
          },
          {
            title: "3. Personal Data",
            points: [
              "The platform may collect user-provided data such as name, email, age, governorate, education level, and national ID when operationally required.",
              "This data is used to manage assessments, generate reporting, measure participation, and improve educational quality.",
              "Learnova may review or reject unclear, inconsistent, or obviously incorrect data."
            ]
          },
          {
            title: "4. Privacy and Data Protection",
            points: [
              "Learnova does not sell personal data and does not share it externally without a valid operational or legal reason.",
              "Aggregated or statistical usage may be used for analysis and service improvement.",
              "Reasonable measures are taken to protect user data, although normal internet and infrastructure risks still apply."
            ]
          },
          {
            title: "5. Assessments and Results",
            points: [
              "The platform may display scores, analytics, comparisons, and AI-assisted reports based on submitted data and trainer settings.",
              "AI-generated feedback is intended as educational assistance and should not replace final human judgment.",
              "Visibility of results, answers, and AI reports depends on trainer or admin permissions."
            ]
          },
          {
            title: "6. Acceptable Use",
            points: [
              "Users may not submit fake, abusive, unlawful, or harmful content.",
              "Unauthorized access attempts to accounts, data, or admin-only areas are prohibited.",
              "Users may not act in ways that threaten service stability or database integrity."
            ]
          },
          {
            title: "7. Limitation of Liability",
            points: [
              "Learnova makes reasonable efforts to provide a reliable service, but does not guarantee uninterrupted or error-free operation at all times.",
              "Learnova is not responsible for harm caused by incorrect user data or misuse of accounts.",
              "Important educational or operational decisions should still be reviewed by responsible staff."
            ]
          },
          {
            title: "8. Updates",
            points: [
              "Learnova may update these terms when operational, legal, or product needs change.",
              "Continued use of the platform after updates constitutes acceptance of the revised terms."
            ]
          }
        ]
      };

  return (
    <div className="auth-page">
      <div className="auth-hero">
        <div className="auth-toolbar">
          <img src={brandFullTransparent} alt="Learnova" className="auth-brand-image" />
          <button className="language-toggle language-toggle--ghost" onClick={toggleLanguage} type="button">
            {language === "ar" ? "English" : "العربية"}
          </button>
        </div>
        <h1>{copy.title}</h1>
        <p className="auth-hero__text">{copy.intro}</p>
      </div>

      <div className="auth-card auth-card--wide terms-card">
        <div className="terms-card__header">
          <p className="section-eyebrow">{copy.eyebrow}</p>
          <Link to="/register" className="ghost-link">
            {copy.back}
          </Link>
        </div>

        <div className="terms-stack">
          {copy.sections.map((section) => (
            <section key={section.title} className="terms-section">
              <h3>{section.title}</h3>
              <ul className="flat-list">
                {section.points.map((point) => (
                  <li key={point}>{point}</li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TermsPage;
